export const SET_USER = "setUser";
export const SET_FILTER = "setFilter";
export const SET_LOGO_URL = "setLogoUrl";

export const SET_COMPANY_SELECTION_LIST = 'setCompanySelectionList';
export const GET_COMPANY_SELECTION_LIST = 'getCompanySelectionList';
